<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.7501 0.386168C11.4711 0.173908 11.1371 0.0436215 10.787 0.00919436C10.7432 0.00313283 10.6985 0 10.653 0L10.6307 0.000252713L10.5996 0H1.87639L1.7309 0.00547261C0.770049 0.0780065 0 0.862855 0 1.83903V20.4355L0.00570296 20.5804C0.0812598 21.5362 0.897903 22.2745 1.87639 22.2745H9.68458L9.79752 22.268C10.2792 22.2121 10.653 21.8027 10.653 21.3061L10.6465 21.1931C10.5906 20.7115 10.1812 20.3376 9.68458 20.3376H1.93692V1.93692H9.68458V4.54206L9.69018 4.68738C9.76431 5.6464 10.566 6.4015 11.544 6.4015H14.5269V8.71612L14.5334 8.82907C14.5893 9.31072 14.9987 9.68458 15.4953 9.68458C16.0302 9.68458 16.4638 9.25099 16.4638 8.71612V5.51968L16.4623 5.48749C16.4633 5.46947 16.4638 5.45132 16.4638 5.43304L16.4573 5.3201C16.4523 5.27766 16.4447 5.23605 16.4344 5.19546C16.3638 4.80887 16.1683 4.4525 15.8739 4.18081L11.8861 0.500155L11.7501 0.386168ZM11.6205 4.46362L11.621 2.89181L13.3247 4.46405L11.6205 4.46362Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.4126 7.73836L23.0081 9.23683C23.8199 9.70557 24.0981 10.7437 23.6294 11.5556L17.5557 22.0755C17.3703 22.3965 17.0851 22.648 16.7434 22.7916L14.1324 23.8892C13.4125 24.1918 12.5836 23.8535 12.281 23.1336C12.2323 23.0178 12.1993 22.896 12.1828 22.7715L11.8087 19.9492C11.7596 19.5783 11.8343 19.2015 12.0214 18.8775L18.0939 8.35967C18.5626 7.5478 19.6008 7.26963 20.4126 7.73836ZM15.9188 21.0368L20.227 13.5749L18.0463 12.3159L13.7391 19.7762L14.0128 21.8375L15.9188 21.0368ZM21.8322 10.7945L21.1954 11.8975L19.0148 10.6385L19.6516 9.53552L21.8322 10.7945Z"
      :fill="color"
    />
    <path
      d="M12.1057 15.0111C12.1057 14.4762 11.6721 14.0426 11.1373 14.0426H4.35806L4.24512 14.0492C3.76347 14.1051 3.3896 14.5144 3.3896 15.0111C3.3896 15.546 3.8232 15.9796 4.35806 15.9796H11.1373L11.2502 15.973C11.7319 15.9171 12.1057 15.5078 12.1057 15.0111Z"
      :fill="color"
    />
    <path
      d="M11.1373 10.1688C11.6721 10.1688 12.1057 10.6024 12.1057 11.1373C12.1057 11.6339 11.7319 12.0433 11.2502 12.0992L11.1373 12.1057H4.35806C3.8232 12.1057 3.3896 11.6721 3.3896 11.1373C3.3896 10.6406 3.76347 10.2313 4.24512 10.1753L4.35806 10.1688H11.1373Z"
      :fill="color"
    />
    <path
      d="M9.20035 7.26344C9.20035 6.72857 8.76676 6.29498 8.23189 6.29498H4.35806L4.24512 6.30149C3.76347 6.35744 3.3896 6.76678 3.3896 7.26344C3.3896 7.7983 3.8232 8.23189 4.35806 8.23189H8.23189L8.34484 8.22538C8.82649 8.16943 9.20035 7.7601 9.20035 7.26344Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'JobsIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
